<template>
    <button class="input-toggle"
         v-bind:state="valueLabel"
         v-on:click="toggle"></button>
</template>

<script>
    export default {
        computed : {
            valueLabel() {
                return this.value ? 'on' : 'off';
            }
        },

        methods : {
            toggle() {
                this.$emit('input', !this.value);
            }
        },

        props : ['value']
    }
</script>